export default (data: {[index: string]: any}[] ) => {
  const headers = Object.keys(data[0]);
  let csv = `${headers.join(',')}\n`
  data.forEach(row => {
    csv += headers.map(header => row[header] || '').join(',')
    csv += "\n";
  });
  const el = document.createElement('a');
  el.href = 'data:text/csv;charset=utf-8,' + encodeURI(csv);
  el.target = '_blank';
  el.download = 'results.csv';
  el.click();
};
